import {useEffect, useSyncExternalStore} from "react";

let networkStatusListeners = [];
let networkRequestListeners = [];
const networkStatus = {
  online: false,
  isNetworkRequestInProgress: false
}

const emitNetworkStatusChange = () => networkStatusListeners.forEach((listener) => listener());
const emitNetworkRequestStatusChange = () => networkRequestListeners.forEach((listener) => listener());

export const networkStatusStore = {
  getNetworkStatusSnapshot: () => networkStatus.online,
  updateNetworkStatus: (isOnline) => {
   networkStatus.online = isOnline;
   emitNetworkStatusChange();
  },
  subscribeToNetworkStatus: (listener) => {
    networkStatusListeners = [...networkStatusListeners, listener]
    return () => {
      networkStatusListeners = networkStatusListeners.filter((l) => l !== listener)
    }
  },
  getNetworkRequestStatusSnapshot: () => networkStatus.isNetworkRequestInProgress,
  updateNetworkRequestStatus: (isLoading) => {
    networkStatus.isNetworkRequestInProgress = isLoading;
    emitNetworkRequestStatusChange();
  },
  subscribeToNetworkRequestStatus: (listener) => {
    networkRequestListeners = [...networkRequestListeners, listener];
    return () => {
      networkRequestListeners = networkRequestListeners.filter((l) => l !== listener)
    }
  }
}

const useNetworkState = () => {
  const online = useSyncExternalStore(networkStatusStore.subscribeToNetworkStatus, networkStatusStore.getNetworkStatusSnapshot);
  const isNetworkRequestInProgress = useSyncExternalStore(networkStatusStore.subscribeToNetworkRequestStatus, networkStatusStore.getNetworkRequestStatusSnapshot);

  const onNetworkStateChange = ({ type }) => networkStatusStore.updateNetworkStatus(type === "online")

  useEffect(() => {
    networkStatusStore.updateNetworkStatus(navigator.onLine);
    window.addEventListener("online", onNetworkStateChange);
    window.addEventListener("offline", onNetworkStateChange);
    return () => {
      window.removeEventListener("online", onNetworkStateChange);
      window.removeEventListener("offline", onNetworkStateChange);
    }
  }, [])

  return {
    online,
    isNetworkRequestInProgress
  };
}

export default useNetworkState;